import * as React from 'react';
import { IRadioProps } from './IRadioProps';
import { RadioSwitchItem } from './RadioSwitchItem';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${(props) => props.theme.colors.defaultContentBackground};
  border: 1px solid ${(props) => props.theme.colors.defaultContentBorder};
  padding: ${(props) => `${props.theme.spacing.baseValue - 2}${props.theme.spacing.baseUnit}`};
`;
/**
 * A radio input group that can have a single input checked at any one time.
 */
export const RadioSwitch: React.FC<IRadioProps> = ({
  name,
  onChange,
  options,
  value: propValue,
  autoFocus,
  'data-test-id': dataTestId,
  'data-test-class': dataTestClass,
}) => {
  return (
    <StyledWrapper>
      {options.map(({ label, value }, i) => {
        const id = `${name}-${i}`;
        return (
          <RadioSwitchItem
            checked={propValue === value}
            id={id}
            key={id}
            label={label}
            name={name}
            onChange={onChange}
            value={value}
            data-test-id={dataTestId}
            data-test-class={dataTestClass}
            autoFocus={autoFocus ? propValue === value : autoFocus}
          />
        );
      })}
    </StyledWrapper>
  );
};
